import { inject } from '@angular/core';
import { CanMatchFn, Data, Route, Router } from '@angular/router';
import { Pages } from '@shared/constants';
import { ProjectType } from '@shared/models';

import { DataService } from '../services/data.service';

export const projectTypeGuard: CanMatchFn = (route: Route) => {
  const router: Router = inject(Router);
  const dataService: DataService = inject(DataService);

  const projectType = (route.data as Data)['type'] as ProjectType;

  if (dataService.environment().projectType !== projectType) {
    return router.parseUrl(Pages.SORRY);
  }
  return true;
};

/**
 * Same runtime check as {@link projectTypeGuard}, but rejects with `false`
 * instead of redirecting, so the router carries on matching the remaining
 * routes. Use it where two project types own the same path and each brings
 * its own component.
 */
export const projectTypeMatchGuard: CanMatchFn = (route: Route) =>
  inject(DataService).environment().projectType ===
  ((route.data as Data)['type'] as ProjectType);
